/**
 * Der heutige Kalendertag in Europe/Berlin als `YYYY-MM-DD` - der explizite `paidOn` von "Bezahlt markieren"
 * (Spec 2026-09-17: die UI sendet stets einen ISO-Kalendertag). `todayIso()` (lib/format.ts) rechnet in UTC und
 * laege zwischen 22:00/23:00 und Mitternacht UTC einen Tag zu frueh. Neu seit der Ist-Zahlung, kein Teil der
 * Portierung aus `index.html`.
 */
export function berlinHeute(jetzt: Date = new Date()): string {
  const teile = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Europe/Berlin",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(jetzt);
  const wert = (art: string): string => teile.find((t) => t.type === art)?.value ?? "";
  return `${wert("year")}-${wert("month")}-${wert("day")}`;
}
